<template>
  <div class="container-fluid">
    <div class="row container-showcase align-start justify-space-between">
      <!--      player-->
      <v-col
        cols="12"
        class="wow fadeInLeftBig col-lg-7 col-xl-7 player"
        style="position: relative"
      >
        <player
          :poster-url="ctnShowcase.url_poster"
          :is-control-scene="true"
          :video-plr="video"
          @nextScene="onNextMainScene"
          @preScene="onPreMainScene"
        >
        </player>
        <content-same-showcase
          :title="ctnShowcase.title"
          :type-show-case="Number(ctnShowcase.type_showcase)"
          :showcase-id="ctnShowcase.showcase_id"
          @selectContent="handleChangeContent"
        />
      </v-col>
      <v-col
        cols="12"
        class="col-xl-5 col-lg-5 mt-lg-0 mt-md-12 mt-sm-12 mt-xs-12"
      >
        <div class="title-demo">
          <h5>Demo {{ $t("poster_title") }}</h5>
          <span>
            {{ $t("poster_des") }}
          </span>
        </div>
        <transition name="slide-fade">
          <div class="wow fadeInRight" style="position: relative">
            <v-card
              width="100%"
              min-height="100px"
              height="auto"
              style="z-index: 2"
            >
              <v-card-text>
                <div
                  class="pa-xl-6 pa-lg-4"
                  style="max-height: 60vh; overflow-y: auto; overflow-x: hidden"
                >
                  <div v-if="shops" class="wow fadeInUp mb-2">
                    <div class="row row--dense">
                      <v-col cols="4" v-for="(shop, idx) in shops" :key="idx">
                        <img
                          class="wow slideInUp poster-img"
                          @click="seekVideo(Number(shop.time_code))"
                          :src="shop.url_poster"
                        />
                      </v-col>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <div class="close-panel" v-if="showPrPanel" role="user">
              <div class="title-panel-close justify-space-between">
                <small class="mr-4">Posters images</small>
              </div>
            </div>
          </div>
        </transition>
      </v-col>
    </div>
  </div>
</template>

<script>
import Player from "./components/Player";
import ContentSameShowcase from "./components/ContentSameShowcase";
import { playerShowcase } from "../../minxin/player-showcase";
// import _ from "lodash";
export default {
  name: "PosterImages",
  mixins: [playerShowcase],
  components: { Player, ContentSameShowcase },
  methods: {
    getCurrentMetaWithPos() {
      /*
       * Get meta data tại thời điểm video hiện tại
       * */
      let res = [];
      if (this.timePlay) {
        const messages = this._getMetaDataInTime(
          this.showcaseCr.data,
          this.timePlay
        );
        for (let message of messages) {
          for (const img of message.data) {
            res.push(img);
          }
        }
      }
      return res;
    },
    _makeShowCaseMainScene() {
      for (const scene of this.showcaseCr.data || []) {
        this.showcaseMainScene.push(scene.itv[0]);
      }
    },
    _addEventTimeUpdateAndFullScreen(video) {
      const updateAdsPosition = () => {
        this.shops = this.getCurrentMetaWithPos();
      };
      video.addEventListener("timeupdate", () => {
        this.timePlay = this.video.currentTime;
        updateAdsPosition();
      });
      video.addEventListener("fullscreenchange", () => {
        updateAdsPosition();
      });
      return video;
    },
  },
};
</script>

<style scoped lang="scss">
.poster-img {
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}
</style>
